const { stringify } = require("qs");
const {
  AYANA_KOMODO_ID,
  AYANA_LAKODIA_ID,
  AYANA_RESORT_ID,
  AYANA_RIMBA_JIMBARAN_ID,
  AYANA_VILLA_ID,
  AYANA_JAKARTA_ID,
} = require("../../src/store/constants/pageContext");

const urlPath = {
  [AYANA_KOMODO_ID]: "labuan-bajo/komodo",
  [AYANA_LAKODIA_ID]: "labuan-bajo/lakodia",
  [AYANA_RESORT_ID]: "bali/ayana-resort-and-spa",
  [AYANA_RIMBA_JIMBARAN_ID]: "bali/rimba-jimbaran",
  [AYANA_VILLA_ID]: "bali/the-villas-at-ayana",
  [AYANA_JAKARTA_ID]: "jakarta/ayana-midplaza-jakarta",
};

exports.urlPath = urlPath;

exports.roomPath = ({ hotel, room }) => {
  const url = urlPath[hotel.id];
  if (room) {
    return `/${url}/rooms/${room.name_en
      .toLocaleLowerCase()
      .replace(/ /g, "-")}`;
  } else {
    return `${url}/rooms/`;
  }
};

exports.filterKomodoActivities = ({ activities }) =>
  activities.filter((activity) => activity.hotels[0].hotel_code === "AKWB");

exports.activitiesPath = ({ activityName }) =>
  `labuan-bajo/komodo/experience/${activityName
    .toLocaleLowerCase()
    .replace(/ /g, "-")}`;

exports.packagePath = ({ hotelId, packageName }) => {
  const route =
    hotelId === "4"
      ? "labuan-bajo/komodo/weddings/"
      : (hotelId === "1" || hotelId === "2" || hotelId === "3") &&
        "bali/weddings/";
  return `${route}${packageName.toLocaleLowerCase().replace(/ /g, "-")}`;
};

exports.lakodiaActivitiesPath = ({ activityName }) =>
  `labuan-bajo/lakodia/experience/${activityName
    .toLocaleLowerCase()
    .replace(/ /g, "-")}`;

exports.sailPackagesPath = ({ packageName }) =>
  `labuan-bajo/lakodia/itinerary/${packageName
    .toLocaleLowerCase()
    .replace(/ /g, "-")
    .replace("’", "")}`;

exports.rockbarDetailPagePath = ({ pageName }) =>
  `bali/dining/${pageName
    .toLocaleLowerCase()
    .replace(/ /g, "-")
    .replace(",", "")}`;

exports.spaDetailPagePath = ({ pageName }) =>
  `bali/spa/${pageName
    .toLocaleLowerCase()
    .replace(/ /g, "-")
    .replace(",", "")}`;

exports.experienceRomanticPath = (location) => {
  return `/${location}/experience/#romantic`;
};

exports.addQueryParamToSlug = (slug, params = {}) =>
  `${slug}${stringify(params, { addQueryPrefix: true })}`;
